module.exports = __webpack_public_path__ + "img/iconInvite.77de6f59.svg";